export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  Admin: "/admin",
  BRAND: "/brand",
  ORGANISATION: "/organisations",
  Agency: "/agency",
  AGENCY_INFLUENCER: "/agency/:id",
  INFLUENCER: "/influencer",
  PERMISSIONS: "/permissions",
  SOCIALMEDIA: "/socialMedia",
  BUCKET: "/bucket",
  REQUESTS: "/requests",
  BUCKETINFLUENCERS: "/bucket/:bucketId",
  GLOBAL_DISCOVERY: "/globalDiscovery",
  ADVANCED_YOUTUBE_SEARCH: "/advanced-youtube-search",
  AI_WORKSPACE: "/ai-workspace",
  AI_WORKSPACE_DETAIL: "/ai-workspace/:id",
  BRIEF: "/brief",
  BRIEF_INFLUENCERS: "/brief/influencers/:id",
  INFLUENCER_CAMPAIGN_REACHOUT: "/influencer-campaign-reachout",
  REPORTS: "/reports",
  REPORT_DETAIL: "/reports/:reportId",
  REPORT_MEDIA: "/reports/:reportId/:mediaId",
  BRAND_BILLING: "/brand-billing",
  BRIEF_V2: "/brief/v2/:briefId",
  BRIEF_V2_REPORT: "/brief/v2/:briefId/report",
  BRIEF_V2_BILL: "/brief/v2/:briefId/billing",
  // BRIEF_V2_SETTINGS: "/brief/v2/:briefId/settings",
  BRIEF_V2_CAMPAIGNS: "/brief/v2/:briefId/campaigns",
  BRIEF_V2_OVERVIEW: "/brief/v2/:briefId/overview",
  BRIEF_V2_AI_OVERVIEW: "/brief/v2/:briefId/ai-overview",
  // BRIEF_V2_CONFIG: "/briefs/v2/:briefId/config",
  PRICING_TRACKING: "/pricing-tracking",
  DISCOVERY_TRACKING: "/discovery-tracking",
  BRIEF_V2_SCRIPT: "/script/:scriptId",

  DRAFTING: "/drafting/:draftingId",
  FINANCE_APPROVAL_LOT: "/finance-approval-lot/",
  PAYOUTS: "/payouts",
  GST_INVOICES: "/gst-invoices",
  PRICING_TRACKER: "/pricing-tracker",
  DELIVERABLE_CONFIGURATOR: "/deliverable-configurator",
  INFLUENCER_CONTACT_VERIFICATION: "/influencer-contact-verification",
  ACCOUNTING: "/accounting",
  MY_PRICING: "/my-pricing",
  CLOSURES: "/closures",
  CLOSURE_DETAIL: "/closures/:briefId/:userId",
  MY_PRICING_PROJECT: "/my-pricing/campaign/:briefId",
  PERSONAL_SETTINGS: "/personal-settings",
};
